import React from 'react';
import FileInput from 'components/shared/FileInput';
import { v4 as uuid } from 'uuid';
import { createCfObj } from 'utils/stateToState';

export default class AddUpdateSubsidiary extends React.Component {
  constructor(props) {
    super(props);
    this.handleCF = this.handleCF.bind(this);
  }

  handleCF(file) {
    // TODO: this should be handled async way https://redux.js.org/advanced/async-actions
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = (e) => {
      const cfArrayBuffer = e.target.result;
      let utf8decoder = new TextDecoder();
      let cfString = utf8decoder.decode(cfArrayBuffer);
      this.props.openModal({
        id: uuid(),
        type: 'component',
        data: {
          subId: this.props.subId,
          subsidiary: this.props.subsidiary,
          filename: file.name,
          cfObj: createCfObj(cfString),
        },
        componentType: 'SubsidiaryModal',
      });
    };
  }

  render() {
    return (
      <FileInput
        id={this.props.id}
        handleFile={this.handleCF}
        label={this.props.label}
        title={this.props.title}
        accept=".cf"
      />
    );
  }
}
